import { render, staticRenderFns } from "./CateringMenu.vue?vue&type=template&id=a420f746"
import script from "./CateringMenu.vue?vue&type=script&lang=js"
export * from "./CateringMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports